export enum UserStatsCategory {
    CollectionGeneral,
    CollectionGameMagic
}